import { render } from "./JoinUsBox.vue?vue&type=template&id=442f38f6&scoped=true"
import script from "./JoinUsBox.vue?vue&type=script&lang=js"
export * from "./JoinUsBox.vue?vue&type=script&lang=js"

import "./JoinUsBox.vue?vue&type=style&index=0&id=442f38f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442f38f6"]])

export default __exports__